document.addEventListener('DOMContentLoaded', function () {
    console.log('form localstorage loaded');

    // Use Gravity Forms jQuery submit event
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('submit', '#gform_4', function(event) {
            console.log('Form #gform_4 submitted');

            // capture and store education level
            const educationLevel = jQuery('#input_4_9').val();
            if (educationLevel) {
                localStorage.setItem('Job_Education', educationLevel);
                console.log('Stored education level:', educationLevel);
            } else {
                console.log('Education level field not found or empty');
            }

            // capture and store skills list
            const selectedSkills = [];
            jQuery('#field_4_10 input[type="checkbox"]:checked').each(function () {
                selectedSkills.push(jQuery(this).val());
            });
            if (selectedSkills.length > 0) {
                localStorage.setItem('Job_Skills', JSON.stringify(selectedSkills));
                console.log('Stored skills:', selectedSkills);
            } else {
                console.log('No skills selected');
            }

            // capture and store Other skills
            const otherSkills = jQuery('#input_4_11').val();
            if (otherSkills) {
                localStorage.setItem('Job_Other_Skills', otherSkills);
                console.log('Stored other job skills:', otherSkills);
            } else {
                console.log('Other job skills field not found or empty');
            }

            // capture and store wage preference
            const workTiming = [];
            jQuery('#field_4_15 input[type="checkbox"]:checked').each(function () {
                workTiming.push(jQuery(this).val());
            });
            if (workTiming.length > 0) {
                localStorage.setItem('Job_Work_Timing', JSON.stringify(workTiming));
                console.log('Stored work timing:', workTiming);
            } else {
                console.log('No work timing selected');
            }

            // capture and store salary range preference
            const salaryMin = jQuery('#field_4_25 input[type="radio"]:checked').val();
            if (salaryMin) {
                localStorage.setItem('Job_Salary_Minimum', salaryMin);
                console.log('Stored salary minimum:', salaryMin);
            } else {
                console.log('No salary minimum selected');
            }

            // capture and store hourly range preference
            const hourlyMin = jQuery('#field_4_26 input[type="radio"]:checked').val();
            if (hourlyMin) {
                localStorage.setItem('Job_Hourly_Minimum', hourlyMin);
                console.log('Stored hourly minimum:', hourlyMin);
            } else {
                console.log('No hourly minimum selected');
            }

            // capture and store Other skills
            const emailAddress = jQuery('#input_4_22').val();
            if (emailAddress) {
                localStorage.setItem('Job_Email_Address', emailAddress);
                console.log('Stored email address:', emailAddress);
            } else {
                console.log('Email address field not found or empty');
            }


        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const fieldMap = {
        Job_Education: '#input_6_9', 
        Job_Skills: '#field_6_10 input[type="checkbox"]',
        Job_Other_Skills: '#input_6_11',
        Job_Work_Timing: '#field_6_15 input[type="checkbox"]',
        Job_Salary_Minimum: '#field_6_30 input[type="radio"]',
        Job_Hourly_Minimum: '#field_6_31 input[type="radio"]',
        Job_Email_Address: '#input_6_22',
    };

    const interval = setInterval(() => {
        if (!document.querySelector('#gform_6')) return;

        Object.entries(fieldMap).forEach(([key, selector]) => {
            const raw = localStorage.getItem(key);
            if (!raw) return;

            let value;
            try {
                value = JSON.parse(raw);
            } catch (e) {
                value = raw; // fallback to raw string
            }

            // If array: checkboxes
            if (Array.isArray(value)) {
                const checkboxes = document.querySelectorAll(selector);
                checkboxes.forEach(cb => {
                    if (value.includes(cb.value)) {
                        cb.checked = true;
                    }
                });
                console.log(`Populated checkboxes from ${key}:`, value);
            }
            // If string: single input or radio button
            else {
                const field = document.querySelector(selector);
                if (field) {
                    // Check if this is a radio button field
                    if (selector.includes('input[type="radio"]')) {
                        // Find the radio button with matching value and check it
                        const radioButtons = document.querySelectorAll(selector);
                        radioButtons.forEach(radio => {
                            if (radio.value.trim() === String(value).trim()) {
                                radio.checked = true;
                                radio.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        });
                        console.log(`Populated radio button from ${key}:`, value);
                    } else {
                        // Regular input field
                        field.value = value;
                        console.log(`Populated field ${selector} from ${key}:`, value);
                    }
                }
            }
        });

        // Ensure conditional logic is triggered after populating
        setTimeout(() => {
            const triggerBox = document.querySelector('#choice_6_10_25');
            if (triggerBox && triggerBox.checked) {
                triggerBox.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }, 300);

        clearInterval(interval);
    }, 200);
});

document.addEventListener('DOMContentLoaded', function () {
    const triggerCheckbox = document.querySelector('#choice_6_10_25');
    const targetField = document.querySelector('#input_6_11');
    const localStoredValue = localStorage.getItem('Job_Other_Skills');
    let hasPopulated = false;
    let userEditedValue = '';

    function restoreValue() {
        setTimeout(() => {
            const field = document.querySelector('#input_6_11');
            if (!field) return;

            // Restore user-edited value if it exists
            if (userEditedValue) {
                field.value = userEditedValue;
                console.log('Restored user-edited value:', userEditedValue);
            } 
            // Otherwise, restore from localStorage only once
            else if (!hasPopulated && localStoredValue && !field.value) {
                field.value = localStoredValue;
                hasPopulated = true;
                console.log('Restored localStorage value:', localStoredValue);
            }
        }, 100);
    }

    if (triggerCheckbox && targetField) {
        // Listen for user input to preserve it
        targetField.addEventListener('input', () => {
            userEditedValue = targetField.value;
        });

        // Restore value if checkbox is toggled on
        triggerCheckbox.addEventListener('change', function () {
            if (this.checked) {
                restoreValue();
            }
        });

        // Run once on load in case field is already visible
        if (triggerCheckbox.checked) {
            restoreValue();
        }
    }
});
